import SlimSelect from '../../lib/slim-select-custom';

export type SelectOption = {
  text: string,
  value?: string,
  selected?: boolean,
  disabled?: boolean,
  placeholder?: boolean,
};

export default class SlimSelectHelper {
  static SELECTOR = '.js-slimSelect';

  static initAll(): void {
    if (document.querySelector(SlimSelectHelper.SELECTOR)) {
      // eslint-disable-next-line no-new
      new SlimSelect({
        select: SlimSelectHelper.SELECTOR,
        placeholder: '',
      });
    }
  }

  static getPlaceholderFromDataAttribute = (select: SlimSelect): string => select.select.element.dataset.placeholderLabel ?? 'Please select';

  static generatePlaceholder = (select: SlimSelect): SelectOption => ({
    text: SlimSelectHelper.getPlaceholderFromDataAttribute(select),
    value: '',
    placeholder: true,
  });

  static setOptions(select: SlimSelect, options: SelectOption[]): void {
    select.setData([SlimSelectHelper.generatePlaceholder(select), ...options]);
    if (options.length) {
      select.enable();
    }
  }
}
